import { styled, Tab } from '@material-ui/core';

const TallTab = styled(Tab)({
  height: '75px',
});

export default TallTab;
